import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestApi from '@infrastructure/family-fest-api';
export const updateFamilyFestEventSpotsAsync = createAsyncThunk('familyFest/updateEventSpots', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.updateFamilyFestEventSpots(request);
        const body = response.data;
        if (!body.isSuccess || !body.data) {
            return rejectWithValue({ error: body.message, status: response.status });
        }
        return body.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
